/* ---------------------------------------------------------------------------
   Wunderbad – eigene Theme-Erweiterungen
   Wird einmalig aus layout/theme.liquid geladen (defer).
   --------------------------------------------------------------------------- */

/* ---------------------------------------------------------------------------
   Bestellplaner: restock.php genau einmal je Seite laden.
   Nutzer: das Ausverkauft-Badge (unten) und der Lieferstatus auf der
   Produktseite (snippets/lieferstatus-bestellplaner.liquid). Vorher fragte
   jeder fuer sich an - zwei Abfragen je Produktseite, und bei jedem
   Variantenwechsel eine weitere.
   --------------------------------------------------------------------------- */
window.wbBestellplaner = window.wbBestellplaner || (function () {
  var RESTOCK_URL = 'https://bestellplaner.stilform-armaturen.com/restock.php';
  var laufend = null;

  return {
    // Liefert immer dasselbe Promise; Fehler enden als null, nie als Ausnahme.
    laden: function () {
      if (!laufend) {
        laufend = fetch(RESTOCK_URL)
          .then(function (response) { return response.ok ? response.json() : null; })
          .catch(function () { return null; });
      }
      return laufend;
    }
  };
})();

/* ---------------------------------------------------------------------------
   Ausverkauft-Badge: Wiederverfügbarkeits-Datum aus dem Bestellplaner
   Markup kommt aus snippets/ausverkauft-badge.liquid
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var restockData = null;
  var scheduled = false;

  // Auf Produktkarten sitzt das Badge optisch unten links auf dem Bild.
  // Prestige rendert die Badge-Liste oben links – deshalb hängen wir das
  // Ausverkauft-Badge direkt in die Figure um und stylen es über CSS.
  function moveToFigure() {
    document.querySelectorAll('[data-bp-soldout]').forEach(function (badge) {
      if (badge.__bpMoved) return;

      var figure = badge.closest('.product-card__figure');
      if (!figure) return;

      figure.appendChild(badge);
      badge.classList.add('badge--sold-out-card');
      badge.__bpMoved = true;
    });
  }

  function applyDates() {
    if (!restockData) return;

    document.querySelectorAll('[data-bp-soldout]').forEach(function (badge) {
      var slot = badge.querySelector('[data-bp-soldout-date]');
      if (!slot || slot.textContent) return;

      var earliest = null;

      // Ein Termin zaehlt nur, wenn sein Monat nicht schon vorbei ist - sonst
      // stuende auf der Karte "voraus. ab Mai", waehrend August laeuft. Die
      // Produktseite prueft das in lieferstatus-bestellplaner ebenso.
      //
      // Die Pruefung gehoert IN die Schleife, nicht dahinter: sonst gewinnt bei
      // zwei Varianten der aeltere, laengst verfallene Termin das Minimum, wird
      // anschliessend verworfen - und der gueltige Termin der anderen Variante
      // verschwindet mit ihm.
      var jetzt = new Date();
      var monatJetzt = jetzt.getFullYear() * 12 + jetzt.getMonth();

      (badge.getAttribute('data-bp-keys') || '').split('|').forEach(function (key) {
        if (!key) return;
        var iso = restockData[key];
        if (!iso) return;

        var d = new Date(iso + 'T00:00:00');
        if (isNaN(d)) return;
        if (d.getFullYear() * 12 + d.getMonth() < monatJetzt) return;

        if (!earliest || iso < earliest) earliest = iso;
      });

      if (!earliest) return;

      var date = new Date(earliest + 'T00:00:00');
      if (isNaN(date)) return;

      var locale = badge.getAttribute('data-bp-locale') || 'de';
      var formatted = date.toLocaleDateString(locale, { month: 'long', year: 'numeric' });

      slot.textContent = badge.getAttribute('data-bp-back') + ' ' + formatted;
      slot.hidden = false;
    });
  }

  function refresh() {
    moveToFigure();
    applyDates();
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      refresh();
    });
  }

  function init() {
    refresh();

    window.wbBestellplaner.laden().then(function (data) {
      restockData = data;
      applyDates();
    });

    // Prestige lädt Produktkarten per AJAX nach (Filter, Pagination, Quick-Buy).
    new MutationObserver(scheduleRefresh).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
